<!-- eslint-disable @angular-eslint/template/eqeqeq -->
<div class="downtime-modal-content" [class.downtime-modal-v2]="isV2()">
	@if (isV2()) {
		<button
			type="button"
			class="downtime-v2-close"
			(click)="dismiss()"
			[attr.aria-label]="'NOTE_EDITOR__CLOSE' | transloco"
		>
			<span class="material-symbols-outlined material-symbols-outlined--size-24" aria-hidden="true">close</span>
		</button>

		<div class="downtime-v2-heading">{{ "DOWNTIME_MODAL__DOWNTIME" | transloco }}</div>

		<div class="downtime-v2-fields">
			<ng-container *ngLet="templates$ | async as templates">
				@if (templates?.length > 0) {
					<div
						class="downtime-v2-field"
						[style.--template-bar-color]="selectedTemplate?.color || 'transparent'"
					>
						<span class="downtime-v2-field-label">
							{{ "DOWNTIME_MODAL__CHOOSE_TEMPLATE" | transloco }}
						</span>
						<button
							type="button"
							id="downtime-v2-template-trigger"
							class="downtime-v2-control downtime-v2-select-trigger"
							[class.downtime-v2-select-trigger--placeholder]="!selectedTemplate"
						>
							@if (selectedTemplate?.color) {
								<span class="downtime-v2-template-bar" aria-hidden="true"></span>
							}
							<span class="downtime-v2-select-label">
								{{
									selectedTemplate?.name ||
										("DOWNTIME_MODAL__TEMPLATE_PLACEHOLDER" | transloco)
								}}
							</span>
							@if (createsAssignment(selectedTemplate)) {
								<span
									class="material-symbols-outlined material-symbols-outlined--size-24 downtime-v2-select-warning"
									aria-hidden="true"
								>
									warning
								</span>
							}
							<span
								class="material-symbols-outlined material-symbols-outlined--size-24"
								aria-hidden="true"
							>
								arrow_drop_down
							</span>
						</button>
						<ion-popover
							trigger="downtime-v2-template-trigger"
							[dismissOnSelect]="true"
							[keepContentsMounted]="true"
							size="cover"
							side="bottom"
							alignment="start"
							cssClass="rideops-template-select-popover"
						>
							<ng-template>
								<div class="rideops-template-select-menu">
									<button
										type="button"
										class="rideops-template-select-option"
										[class.rideops-template-select-option--selected]="!selectedTemplate"
										(click)="clearTemplate()"
									>
										<span class="rideops-template-select-bar"></span>
										<span class="rideops-template-select-name">
											{{ "DOWNTIME_MODAL__TEMPLATE_NONE" | transloco }}
										</span>
									</button>
									<button
										type="button"
										class="rideops-template-select-option"
										*ngFor="let template of templates"
										[class.rideops-template-select-option--selected]="
											template.id === selectedTemplate?.id
										"
										(click)="toggleTemplate(template)"
									>
										<span
											class="rideops-template-select-bar"
											[style.background]="template.color"
										></span>
										<span class="rideops-template-select-name">{{ template.name }}</span>
										@if (createsAssignment(template)) {
											<span
												class="material-symbols-outlined material-symbols-outlined--size-24 rideops-template-select-warning"
												aria-hidden="true"
											>
												warning
											</span>
										}
									</button>
								</div>
							</ng-template>
						</ion-popover>
					</div>
				}
			</ng-container>

			<div class="downtime-v2-field downtime-v2-field--description">
				<span class="downtime-v2-field-label">{{ "DOWNTIME_MODAL__DESCRIPTION" | transloco }}</span>
				<textarea
					class="downtime-v2-control downtime-v2-textarea"
					rows="5"
					[(ngModel)]="description"
				></textarea>
			</div>
		</div>

		<div class="downtime-v2-actions">
			<button type="button" class="downtime-v2-btn downtime-v2-btn--outlined" (click)="dismiss()">
				{{ "NOTE_EDITOR__CANCEL" | transloco }}
			</button>
			<button
				type="button"
				class="downtime-v2-btn downtime-v2-btn--filled"
				[disabled]="saving"
				(click)="startDowntime()"
			>
				{{ "DOWNTIME_MODAL__START_DOWNTIME" | transloco }}
			</button>
		</div>
	} @else {
		<div class="headline">{{ "DOWNTIME_MODAL__DOWNTIME" | transloco }}</div>

		<ng-container *ngLet="templates$ | async as templates">
			<app-grouping [label]="'DOWNTIME_MODAL__TEMPLATES'" *ngIf="templates?.length > 0">
				<div class="downtime-template-buttons">
					<ion-button
						class="downtime-template-button"
						*ngFor="let template of templates"
						(click)="toggleTemplate(template)"
						[ngStyle]="{ '--background': template.color }"
						[ngClass]="{
							disabled: selectedTemplate && selectedTemplate.id != template.id,
						}"
					>
						<ion-icon
							name="checkmark-circle-outline"
							slot="start"
							*ngIf="template.id == selectedTemplate?.id"
						></ion-icon>
						{{ template.name }}
					</ion-button>
				</div>
			</app-grouping>
		</ng-container>

		<app-grouping [label]="'DOWNTIME_MODAL__DESCRIPTION'">
			<ion-textarea [(ngModel)]="description" class="content-text"></ion-textarea>
		</app-grouping>

		<div class="button-container">
			<div class="close-text">
				{{ "DOWNTIME_MODAL__SET_STATUS_AS_DOWN" | transloco }}
			</div>
			<ion-button
				[disabled]="saving"
				color="primary"
				shape="round"
				class="no-transform"
				(click)="startDowntime()"
			>
				{{ "DOWNTIME_MODAL__START_DOWNTIME" | transloco }}
			</ion-button>
		</div>
	}
</div>
